import React from 'react';
import AppSplash from '@/components/AppSplash';
import ContentLoading from '@/components/ContentLoading';
import { useAppShellMounted } from '@/hooks/appShell';
import { useLoadingDeadline } from '@/hooks/useLoadingDeadline';
import LoadingRecovery from '@/components/LoadingRecovery';

/**
 * umi 约定式 loading 组件 —— 被两处消费，位置完全不同（见 src/hooks/appShell.ts）：
 *
 * 1. `config/config.ts` 的 `initialState.loading`：首屏初始化期间整页还是空的
 *    → 全屏「航迹线性」启动动画（与 public/scripts/loading.js 同一套视觉）。
 * 2. umi 给每个路由组件套的 `<Suspense fallback={...}>`：菜单/页签切到一条
 *    还没下载过的路由时触发。这层 fallback 在 TabLayout 缓存节点**内部**，
 *    所以只能占内容区 —— 侧边栏、面包屑、页签栏原地复用，页面一挂载搜索区
 *    与表头就是同步渲染的，不会等接口。
 *
 * 判据由 TabLayout 提供的 AppShellContext 给出，不做 DOM 嗅探。
 */
const Loading: React.FC = () => {
  const shellMounted = useAppShellMounted();
  const timedOut = useLoadingDeadline(!shellMounted);
  if (timedOut) return <LoadingRecovery />;
  return shellMounted ? <ContentLoading /> : <AppSplash />;
};

export default Loading;
